(function () {
  'use strict';

  function positiveQuantity(value) {
    var text = String(value == null ? '' : value).trim();
    if (!/^\d+$/.test(text)) return '';
    var quantity = Number(text);
    return Number.isSafeInteger(quantity) && quantity >= 1 ? quantity : '';
  }

  function buildOaMessageUrl(basicId, message) {
    var id = String(basicId || '').trim();
    if (!/^@[A-Za-z0-9._-]+$/.test(id)) return '';
    return 'https://line.me/R/oaMessage/' + encodeURIComponent(id) + '/?' + encodeURIComponent(message || '');
  }

  function inferTireSize(productTitle) {
    var title = String(productTitle || '').trim();
    var match = title.match(/(?:^|\s)((?:\d{2,3}\/\d{2,3}R\d{2}(?:\.\d+)?(?:LT)?|\d{2}R\d{2}(?:\.\d+)?)(?:\s+\d{1,2}PR)?)(?=\s|$)/i);
    return match ? match[1].toUpperCase() : '';
  }

  function buildMessage(context) {
    var value = context || {};
    if (value.kind === 'search') {
      return ['【サイズ相談】', '検索したサイズ・型番：' + (value.searchTerm || ''), '商品URL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'faq') {
      return ['【交換場所・保証の相談】', '確認したい内容：', 'ページURL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'cart') {
      return ['【購入前の確認】', '確認したい内容：適合／在庫・納期／交換場所', 'カートURL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'general') {
      return ['【タイヤ相談】', '商品・サイズ：', '希望本数：', 'ページURL：' + (value.pageUrl || '')].join('\n');
    }
    var productSize = String(value.productSize || '').trim() || inferTireSize(value.productTitle);
    var quantity = positiveQuantity(value.quantity);
    return [
      value.kind === 'sold_out' ? '【入荷・代替商品相談】' : (value.kind === 'quote' ? '【商品見積相談】' : '【商品相談】'),
      '商品：' + (value.productTitle || ''),
      'サイズ：' + productSize,
      '希望本数：' + (quantity ? quantity + '本' : '未入力'),
      'URL：' + (value.pageUrl || '')
    ].join('\n');
  }

  function contextFromNode(node) {
    var productTitle = node.dataset.productTitle || '';
    var productSize = node.dataset.productSize || inferTireSize(productTitle);
    if (!node.dataset.productSize && productSize) node.dataset.productSize = productSize;
    return {
      kind: node.dataset.lineKind || 'general',
      productTitle: productTitle,
      productSize: productSize,
      quantity: positiveQuantity(node.dataset.lineQuantity),
      pageUrl: node.dataset.productUrl || window.location.href,
      searchTerm: node.dataset.lineSearchTerm || ''
    };
  }

  function refreshContext(node) {
    var message = buildMessage(contextFromNode(node));
    var url = buildOaMessageUrl(node.dataset.lineBasicId, message);
    var lineAnchor = node.matches('a[data-chaoyang-line]')
      ? node
      : node.querySelector('a[data-chaoyang-line]');
    var copyField = node.querySelector && node.querySelector('[data-line-message-copy]');
    var qrOutput = node.querySelector && node.querySelector('[data-line-qr-output]');
    if (lineAnchor && url) lineAnchor.setAttribute('href', url);
    if (copyField) copyField.value = message;
    if (qrOutput) {
      qrOutput.dataset.lineQrValue = url;
      qrOutput.replaceChildren();
      qrOutput.removeAttribute('data-line-qr-rendered');
    }
  }

  function refresh(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-line-context]')) refreshContext(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-line-context]').forEach(refreshContext);
    }
  }

  function renderQr(panel) {
    var output = panel.querySelector('[data-line-qr-output]');
    var error = panel.querySelector('[data-line-qr-error]');
    if (!output || output.dataset.lineQrRendered === 'true') return;
    try {
      if (typeof window.qrcode !== 'function') throw new Error('QR library unavailable');
      if (!output.dataset.lineQrValue) throw new Error('QR value unavailable');
      var qr = window.qrcode(0, 'M');
      qr.addData(output.dataset.lineQrValue);
      qr.make();
      output.innerHTML = qr.createSvgTag({ scalable: true, margin: 4 });
      output.dataset.lineQrRendered = 'true';
      if (error) error.hidden = true;
    } catch (qrError) {
      output.replaceChildren();
      if (error) error.hidden = false;
    }
  }

  document.addEventListener('chaoyang:quantity-change', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-line-context]').forEach(function (node) {
      node.dataset.lineQuantity = String(positiveQuantity(event.detail && event.detail.quantity));
    });
    refresh(root);
  });

  document.addEventListener('DOMContentLoaded', function () { refresh(document); });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-line-panel-toggle]');
    if (toggle) {
      var panel = toggle.parentElement.querySelector('[data-line-panel]');
      var opening = panel.hidden;
      panel.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) renderQr(panel);
      return;
    }
    var copy = event.target.closest('[data-line-copy]');
    if (!copy) return;
    var field = copy.parentElement.querySelector('[data-line-message-copy]');
    if (!field) return;
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
      field.focus();
      field.select();
      return;
    }
    navigator.clipboard.writeText(field.value).then(function () {
      copy.textContent = 'コピーしました';
    }).catch(function () {
      field.focus();
      field.select();
    });
  });

  window.ChaoyangLineConsult = {
    buildMessage: buildMessage,
    buildOaMessageUrl: buildOaMessageUrl,
    inferTireSize: inferTireSize,
    refresh: refresh
  };
})();
